/**
 * Fixed vertical button rail on the right edge (Telegram / Android / iOS).
 *
 * Shows a button only when the matching URL prop is set. For landing / support — does not replace table row menus
 * (use `TableRowActionsMenu`).
 */
import React from 'react';
import { SiAndroid, SiApple, SiTelegram } from 'react-icons/si';
import { twMerge } from 'tailwind-merge';
import { TELEGRAM_MARK_DATA_URL } from './telegramMarkDataUrl';
/** Kiosk-aligned: use CSS variables when present, fallback when the app does not define them. */
const SUPPORT_RAIL_TRACK = 'border-white/12 bg-[linear-gradient(180deg,var(--Background-Header,#040F29)_0%,color-mix(in_srgb,var(--Background-Header,#040F29)_68%,var(--text-high-light,#22d3ee)_32%)_100%)] shadow-[0_18px_35px_rgba(4,15,41,0.5)]';
const RAIL_ICON_CLASS = 'mx-auto h-6 w-6 md:h-7 md:w-7';
export default function SupportDownloadRail({ telegramUrl, androidUrl, iosUrl, className = '', }) {
    const candidates = [
        {
            id: 'telegram',
            url: telegramUrl,
            label: 'Telegram support',
            Icon: SiTelegram,
            iconClassName: 'text-white',
        },
        {
            id: 'android',
            url: androidUrl,
            label: 'Android app',
            Icon: SiAndroid,
            iconClassName: 'text-[#3DDC84]',
        },
        {
            id: 'ios',
            url: iosUrl,
            label: 'iOS guide',
            Icon: SiApple,
            iconClassName: 'text-[#f5f5f7]',
        },
    ];
    const actions = candidates
        .map((row) => { var _a; return ({ ...row, url: ((_a = row.url) !== null && _a !== void 0 ? _a : '').trim() }); })
        .filter((row) => row.url.length > 0);
    if (actions.length === 0)
        return null;
    return (React.createElement("div", { className: `fixed right-0 top-1/2 z-40 -translate-y-1/2 ${className}` },
        React.createElement("div", { className: `w-[56px] rounded-l-[16px] border border-r-0 px-1.5 py-2 md:w-[68px] md:rounded-l-[20px] md:px-2 md:py-3 ${SUPPORT_RAIL_TRACK}` },
            React.createElement("ul", { className: "flex flex-col gap-2" }, actions.map(({ id, url, label, Icon, iconClassName }) => (React.createElement("li", { key: id },
                React.createElement("button", { type: "button", onClick: () => window.open(url, '_blank', 'noopener,noreferrer'), className: "flex h-[38px] w-[38px] items-center justify-center rounded-lg border border-transparent bg-transparent transition-all duration-200 hover:bg-white/10 md:h-[46px] md:w-[46px] md:rounded-xl", "aria-label": label, title: label }, id === 'telegram' ? (React.createElement("img", { src: TELEGRAM_MARK_DATA_URL, alt: "", className: `${RAIL_ICON_CLASS} object-contain`, draggable: false, "aria-hidden": true })) : (React.createElement(Icon, {
                    className: twMerge(RAIL_ICON_CLASS, iconClassName),
                    'aria-hidden': true,
                }))))))))));
}
